module.exports = __webpack_public_path__ + "img/SideBySideImageGalleries.f1a9f76f.png";